export const aboutUs = [
  {
    id: 1,
    title: "Our Story",
    about:
      "Capital flow was founded in 2011, while Bitcoin was still in its infancy. We saw the potential for bitcoin to revolutionize the financial industry, making payments faster, more secure, and less expensive on a global scale.",
  },
  {
    id: 2,
    title: "Our Mission",
    about:
      "We are pioneers building blockchain payment technology to transform how businesses and people send, receive, and store money around the world.",
  },
  {
    id: 3,
    title: "Our Vision",
    about:
      "Cryptocurrency’s future looks very bright, and we plan on remaining on the forefront of this technology, creating more tools and services for everyone to use in innovative new ways.",
  },
  {
    id: 4,
    title: "Our Values",
    about:
      "Led by 8 former Morgan Stanley Executives, Capital flow's goal is to build the worlds most trustworthy cryptocurrency derivatives trading platform. We leverage a “User-Oriented” approach to develop far more powerful features than any existing exchange. Above all, we place customers first. All of our features and tools are designed with this philosophy in mind. This is why our development team is directly available and constantly gathering feedback, comments, and requests from our community on social media.",
  },
];
